'use strict'

import React, { useCallback } from 'react'
import { useModal } from '../../../_components/Modal'
import { useModifyClassList } from '../../../common/utils/CSSUtils'
import RequiredColumnsModal from './RequiredColumnsModal'

/**
 * 汎用マッピング設定の状況モーダルを標準 useModal + promisify で表示するフック。
 *
 * @returns {(data: {
 *   dashboardName: string
 *   graphName: string
 *   periodKind?: string
 *   requiredColumnsGrouped: {
 *     set: string[]
 *     unset: string[]
 *     remove: string[]
 *     setFromMonthlyTask?: string[]
 *     setFromPrimaryTask?: string[]
 *     unsetFromMonthlyTask?: string[]
 *     unsetFromPrimaryTask?: string[]
 *     removeFromMonthlyTask?: string[]
 *     removeFromPrimaryTask?: string[]
 *   }
 * }) => Promise<void>}
 */
export function useRequiredColumnsModal() {
  const showModal = useModal()
  const { promisify } = useModifyClassList('.modal-window', ['w-[650px]'])

  return useCallback(
    (data) => {
      return promisify((res) => {
        showModal({
          title: '汎用マッピング設定の状況',
          body: (
            <RequiredColumnsModal
              dashboardName={data.dashboardName}
              graphName={data.graphName}
              periodKind={data.periodKind}
              requiredColumnsGrouped={data.requiredColumnsGrouped}
            />
          ),
          button: [
            {
              name: '閉じる',
              className: 'footer-btn button_base',
              click: () => res(),
              close: true
            }
          ],
          onClose: res,
          isCancel: false,
          isWide: false,
          modalStyle: { width: '650px' }
        })
      })
    },
    [showModal, promisify]
  )
}
